import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Platform} from '@ionic/angular';
import {parsePhoneNumberFromString} from 'libphonenumber-js';
// stores
import {MerchantStore} from '../../../../core/stores/merchant.store';
import {RestaurantStore} from 'src/app/core/stores/restaurant.store';
// services
import {RouteService} from '../../../../core/services/route.service';
import { Merchant, Restaurant, RestaurantAddress, WorkDay, WorkTime } from '../../../../core/models/restaurant.model';
import {DefaultImageColorsModel} from 'src/app/core/models/default-image-colors.model';
// models
// rxjs
import {filter} from 'rxjs/operators';
import {Title} from '@angular/platform-browser';
import {FormatDataService} from '../../../../core/services/format-data.service';
import {SwipeGestureService} from 'src/app/core/services/swipe-gesture.service';
import {UtilService} from 'src/app/core/services/util.service';
import {StorageService} from 'src/app/core/services/storage.service';
import {CartStore} from 'src/app/core/stores/cart.store';
import {OrderApiService} from 'src/app/core/services/order.api.service';
import {Platforms} from 'src/app/core/enums/util.enum';
import {MerchantCatalog} from '../../../../core/models/catalog.model';

declare let launchnavigator;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  constructor(
    public router: Router,
    public restaurantStore: RestaurantStore,
    public merchantStore: MerchantStore,
    public routeService: RouteService,
    private route: ActivatedRoute,
    private titleService: Title,
    private formatDataService: FormatDataService,
    private swipeGestureService: SwipeGestureService,
    private utilService: UtilService,
    private storageService: StorageService,
    private cartStore: CartStore,
    private orderApiService: OrderApiService,
    private platform: Platform
  ) {
    this.restaurantLoading = true;
  }
  public defaultImageUrl = './assets/images/restaurant_default_logo.svg';
  public googleMapsImageUrl: string;
  public shareImageUrl = './assets/images/share_icon.svg';
  public arrowUp = './assets/images/caret-up-outline.svg';
  public arrowDown = './assets/images/caret-down-outline.svg';
  public restaurantClosedSign = './assets/images/restaurant_closed_sign.svg';
  public restaurantPreordersSign = './assets/images/preorders_sign.svg';
  public merchant = new Merchant();
  public isHome = false;
  public nextOpenTimeUtc;
  public restaurantLength: number;
  public restaurants: Restaurant[];
  public restaurantsDefault: Restaurant[];
  public colorsEnum = DefaultImageColorsModel;
  public isScrollPositionTop = true;
  public blackoutedDays = {};
  public merchantCatalog: MerchantCatalog[] = [];
  public selectedCategory: string[] | null = null;
  public filteredWorkDays: WorkDay[][] = [];

  private readonly firstRestaurantIndex = 0;

  public chosenRestaurant: Restaurant;
  private restaurantLoading: Boolean = false;

  foods = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'}
  ];

  protected readonly filter = filter;

  ionViewDidEnter() {
    if (!this.restaurantLoading) {
      this.restaurantStore.updateWorkHours(this.routeService.getMerchantId());
    }
    this.swipeGestureService.swipebackEnabled = false;
  }

  ionViewDidLeave() {
    this.swipeGestureService.swipebackEnabled = true;
  }

  ngOnInit() {
    this.googleMapsImageUrl = this.platform.is(Platforms.CORDOVA) ? './assets/icon/right-arrow-black.svg' : './assets/images/google_maps_icon.svg';
    this.merchantStore.bootstrapRestaurantData(this.routeService.getMerchantId());
    this.restaurantStore.checkRouteContainsDiscountOption();
    this.merchantStore.merchantIsAvailable$.subscribe((value) => {
      if (!value) {
        this.merchantStore.setMerchantIsAvailable(true);
        this.redirectToFindMerchantPage();
      }
    });

    this.restaurantStore.filteredWorkHours$.subscribe((result: any) => {
      if (this.restaurants) {
        for (const restaurant of this.restaurants) {
          this.blackoutedDays[restaurant.locationId] = this.formatDataService.formatIfStoreContinueWorking(result[restaurant.locationId]);
        }
      }
    });

    this.restaurantStore.restaurants$.pipe(filter(Boolean)).subscribe((restaurants: Restaurant[]) => {
      this.restaurantLength = restaurants.length;
      this.restaurants = restaurants;
      this.restaurantsDefault = restaurants;
      if (restaurants.length === 1) {
        const restaurant = restaurants[this.firstRestaurantIndex];
        this.restaurantStore.timezone = restaurants[this.firstRestaurantIndex].timezone;
        this.goToRestaurantPage(restaurant);
      }
      if (this.restaurantStore.filteredWorkHours) {
        this.restaurantStore.timezone = restaurants[this.firstRestaurantIndex].timezone;
        for (const restaurant of restaurants) {
          this.blackoutedDays[restaurant.locationId] = this.formatDataService.formatIfStoreContinueWorking(
            this.restaurantStore.filteredWorkHours[restaurant.locationId]
          );
        }
      }
    });

    this.merchantStore.merchantData$.pipe(filter(Boolean)).subscribe((merchant: Merchant) => {
      this.merchant = merchant;
      this.getMerchantCatalog();
      if (this.merchant.merchantName) {
        this.titleService.setTitle(this.merchant.merchantName);
      }
    });

    const modeValue = this.route.snapshot.queryParams.mode;

    if (!localStorage.getItem('mode')) {
      localStorage.setItem('mode', modeValue);
    }

    setTimeout(() => {
      this.restaurantLoading = false;
    }, 1000);

    this.getStoreHours();
  }

  public restaurantWorkDays(restaurant: Restaurant) {
    return this.filteredWorkDays[restaurant.locationId].map(day => day.dayType.dayType.substr(0,3));
  }

  public restaurantWorkHours(restaurant: Restaurant) {
    if (this.filteredWorkDays[restaurant.locationId]) {
      return this.filteredWorkDays[restaurant.locationId].map(day => day.enable ? this.formatDataService.formatWorkDay(day) : `Closed ${day.isBlackouted ? `(${day.blackoutDayName})` : ''}`);
    }
    return restaurant.hoursOfOperation.map(day => day.enable ? this.formatDataService.formatWorkDay(day) : 'Closed' );
  }

  public getLocationImage(restaurant: Restaurant): string {
    return restaurant.locationImageUrl || restaurant.logoUrl || this.defaultImageUrl;
  }

  public isHideSigns(restaurant): boolean {
    return restaurant.hideAllSigns;
  }

  
public filterRestaurants(locationIds: string[] | null): void {
  if (!locationIds || locationIds.length === 0) {
    this.restaurants = this.restaurantsDefault;
    return;
  }

  this.restaurants = this.restaurantsDefault.filter(location =>
    locationIds.includes(location.locationId)
  );
}

  public async goToRestaurantPage(restaurant: Restaurant): Promise<void> {
    this.restaurantStore.activeLocationIndex = this.restaurants.findIndex((res) => res.locationId === restaurant.locationId);
    const currentRestaurantId = await this.storageService.get('currentRestaurantId');
    if (currentRestaurantId !== restaurant.locationId) {
      this.cartStore.deleteItemsFromCartByLocationId(currentRestaurantId);
      this.orderApiService.removeLocationFromOrderMap(currentRestaurantId);
      this.storageService.remove('currentRestaurantId');
    }
    this.storageService.set('currentRestaurantId', restaurant.locationId);
    this.chosenRestaurant = restaurant;
    this.nextOpenTimeUtc = restaurant.nextOpenTimeUtc;
    const url = this.routeService.getBaseUrl();
    const baseUrl = url.split('?');
    const urlParams = baseUrl[1] ? baseUrl[1].split('=') : null;
    const param = urlParams ? urlParams[0] : null;
    const value = urlParams ? urlParams[1] : null;
    this.router.navigate([baseUrl[0], 'locations', restaurant.locationId], { queryParams: { [param]: value } });
  }

  public getDay(restaurantHours: WorkDay[], dayId): string {
    if (restaurantHours) {
      if (restaurantHours[dayId].enable) {
        return `${this.formatDataService.formatWeekDay(restaurantHours[dayId])}   ${this.formatDataService.formatWorkDay(restaurantHours[dayId])}`;
      } else {
        return `${this.formatDataService.formatWeekDay(restaurantHours[dayId])}   Closed ${
          restaurantHours[dayId].isBlackouted ? `(${restaurantHours[dayId].blackoutDayName})` : ''
        }`;
      }
    }
  }

  public restaurantAllowScheduledOrders(restaurant): boolean {
    return restaurant.allowScheduledPickups && restaurant.isMobileEnabled && this.isRestaurantHaveEnabledWorkDays(restaurant);
  }

  public isRestaurantHaveEnabledWorkDays(restaurant: Restaurant): boolean {
    return !!restaurant.hoursOfOperation.find((day) => day.enable === true);
  }

  public showHoursInfo(restaurant: Restaurant): void {
    event.stopPropagation();
    restaurant.showHoursInfo = !restaurant.showHoursInfo;
  }

  public formatPhoneNumber(phone: string, formatType: string, country: any = 'US'): string {
    if (phone) {
      const phoneNumber = parsePhoneNumberFromString(phone.toString(), country);
      if (formatType === 'national') {
        return phoneNumber.formatNational();
      } else if (formatType === 'international') {
        return phoneNumber.formatInternational();
      }
    }
    return '';
  }

  public openLocationInMaps(location: RestaurantAddress): void {
    this.utilService.openLocationInMaps(location);
  }

  public backToKyooTechPage(): void {
    const baseUrl = this.routeService.getKyooTechPage();
    this.router.navigate([baseUrl]).catch((error) => console.log(error));
  }

  public redirectToFindMerchantPage(): void {
    const baseUrl = this.routeService.getFindMerchantPage();
    this.router.navigate([baseUrl]).catch((error) => console.log(error));
  }
  private getMerchantCatalog(): void {
    this.orderApiService.getMerchantCatalog(this.merchant.merchantId).subscribe(response => {
      this.merchantCatalog = response;
    });
  }

  private getStoreHours(): void {
    this.restaurantStore.filteredWorkHours$
      .pipe(filter(Boolean))
      .subscribe((result: any) => {
        this.filteredWorkDays = result;
        this.restaurants.map(restaurant => {
          this.filteredWorkDays[restaurant.locationId] = this.formatDataService.formatIfStoreContinueWorking(result[restaurant.locationId]);
        });
      });
  }
}
